<template>
  <div style="display: inline-block;">
  </div>
</template>

<script>
import api from '../../services/api.js'
import { API_HOST, FILE_HOST } from '../../services/constant.js'

let $ = require('jQuery')

export default {
  name: 'logout',
  data () {
    return {
      fromPath: ''
    }
  },
  created () {
    this.logoutBbs()
  },
  mounted(){
     this.$nextTick(()=>{
       console.log(this.fromPath)
     })
  },
  methods: {
    async logout () {
      let res = await api.post(this, {
        path: 'passport.php',
        api: 'logout'
      })
      this.$localStorage.remove('token')
      this.$localStorage.remove('openid')
      this.$localStorage.remove('username')
      this.$localStorage.remove('taskInfo')
      this.$localStorage.remove('account_id')
      this.$localStorage.remove('goBackOrderUrl')
      sessionStorage.removeItem('isSingle')
      sessionStorage.removeItem('role')
      // if (window.innerWidth <= 768 || this.fromPath == '/' || this.fromPath) {
      //   this.$router.push({path: '/'})
      // } else {
      //   this.$router.push({path: '/login',query: {href: this.fromPath}})
      // }
      // this.$router.push({path: this.fromPath})
      window.location.href = document.referrer;
      // window.location.reload()
    },
    logoutBbs() {
      // if(API_HOST == '//api-test.joyorders.com'){
      //   this.logout()
      //   return
      // }
      try {
        $('#bbsIframe').remove()
        document.domain = 'joyorders.com'
        var ifr = document.createElement('iframe')
        ifr.id = 'bbsIframe'
        ifr.src = 'https://bbs.joyorders.com/forum.php?joyordersBbsAutoLogin=true'
        ifr.style.display = 'none'
        document.body.appendChild(ifr)
        ifr.onload = () => {
          var doc = ifr.contentDocument || ifr.contentWindow.document
          try {
            doc.getElementById('joyorders_logout').click()
          } catch(e) {

          }
          this.logout()
        }
      } catch(e) {
        this.logout()
      }
    }
  },
  beforeRouteEnter (to, from, next){
    console.log(document.referrer)
    next(vm => {
       vm.fromPath = from.fullPath
     })
   },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/passport/Logout.vue